<!-- 院长端 -->
<template>
	<div class="data-view" ref="view">
		<div class="page-title">
			<div class="text">
				<div v-if="!isShowSeach">
					<span>关于“{{ seachText }}”共搜索到</span>
					<span class="text-totle">{{ total }}</span>
					<span>条结果</span>
				</div>
				<div v-if="!isShowSeach" class="text-back" @click="back">返回</div>
				<div style="width:240px;margin:0 10px">
					<a-range-picker :disabledDate="disabledDate" :value="seachPicker" @change="onChangeRangeDate">
						<template #suffixIcon>
							<a-icon style="color:#1890ff;" type="calendar" />
						</template>
					</a-range-picker>
				</div>
				<div style="width:160px;" v-if="isShowSeach">
					<el-input size="mini" placeholder="请输入位置关键字" v-model="seachText" @keyup.enter.native="seach(1)">
						<i slot="suffix" class="el-input__icon el-icon-search" @click="seach(1)"></i>
					</el-input>
				</div>
			</div>
			<div class="top-btn">
				<el-button size="small" @click="toExportExcele">导出</el-button>
				<el-button size="small" v-print="printObj">打印</el-button>
			</div>
		</div>
		<div class="page-con" v-if="!isEmpty">
			<div class="con-title">
				<div class="bed-name" :class="{ 'bed-name-active': isActive == index }" v-for="(item, index) in tableData"
					:key="index" :style="{ 'z-index': index, top: index * 70 + 'px' }" @click="changeBedName(index)">
					{{ item ? (item.bedName || '') : '' }}
				</div>
			</div>

			<!-- 页面主要表格区域 -->
			<el-table v-if="!isEmpty && tableData" :data="tableData[isActive].dataList" border :cell-style="cellStyle"
				:header-cell-style="headerCellStyle" :row-class-name="rowClassName" style="flex: 1; margin: 10px 0 0 160px;"
				:span-method="showTableSpanMethod" :header-cell-class-name="headerClass" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
				<!-- 动态生成两级表头 -->
				<template v-for="(group, groupIndex) in getHeaderGroups(tableData[isActive].headerList)">
					<!-- 表头组（第一级） -->
					<el-table-column 
						:key="groupIndex"
						:label="group.groupName"
						:colspan="group.columns.length"
						align="center"
						:class-name="group.markedRed ? 'text-red' : ''">
						<!-- 子列（第二级） -->
						<template v-for="(col, colIndex) in group.columns">
							<el-table-column
								:key="colIndex"
								:label="col.columnZh"
								:class-name="col.markedRed ? 'text-red' : ''"
								align="center"
								min-width="160">
								<template slot-scope="scope">
									<div 
										v-html="scope.row[group.startIndex + colIndex] ? scope.row[group.startIndex + colIndex].dataName : ''"
										:style="{ color: scope.row[group.startIndex + colIndex] && scope.row[group.startIndex + colIndex].markedRed ? 'rgba(255, 77, 79, 1)' : 'rgba(89, 89, 89, 1)' }">
									</div>
								</template>
							</el-table-column>
						</template>
					</el-table-column>
				</template>
			</el-table>

			<!-- 打印用表格区域 -->
			<div id="printMe" style="display: none;">
				<div v-for="(bedGroup, bedIndex) in printAllGroups" :key="bedIndex" class="bed-print-section">
					<div class="bed-print-title">{{ bedGroup.bedName }}</div>
					<div v-for="(dynamicGroup, groupIndex) in bedGroup.headerGroups" :key="`${bedIndex}-${groupIndex}`"
						class="print-table-group">
						<el-table :data="formatPrintTableData(bedIndex, groupIndex)" border size="mini" :cell-style="printCellStyle"
							:header-cell-style="printHeaderStyle" :row-class-name="printRowClassName"
							:span-method="(params) => printTableSpanMethod(params, bedGroup)" :header-cell-class-name="headerClass">
							<!-- 固定前4列表头：改用处理后的headerFixed，隐藏colspan=0的列 -->
							<el-table-column 
								v-for="(fixedGroup, fixedGroupIndex) in getHeaderGroups(bedGroup.headerFixed)" 
								:key="`fixed-group-${bedIndex}-${fixedGroupIndex}`"
								:label="fixedGroup.groupName"
								:colspan="fixedGroup.columns.length"
								:class-name="fixedGroup.markedRed ? 'text-red' : ''"
								align="center">
								<template v-for="(fixedCol, fixedIdx) in fixedGroup.columns">
									<el-table-column
										:key="`fixed-${bedIndex}-${fixedGroupIndex}-${fixedIdx}`"
										:label="fixedCol.columnZh"
										:width="fixedCol.width || 120"
										:class-name="fixedCol.markedRed ? 'text-red' : ''"
										align="center">
										<template slot-scope="scope">
											<div 
												v-html="scope.row.fixed[fixedGroup.startIndex + fixedIdx].dataName || ''"
												:style="{ color: scope.row.fixed[fixedGroup.startIndex + fixedIdx].markedRed ? 'rgba(255, 77, 79, 1)' : 'rgba(89, 89, 89, 1)' }">
											</div>
										</template>
									</el-table-column>
								</template>
							</el-table-column>

							<!-- 动态列：改用处理后的dynamicGroup，隐藏colspan=0的列 -->
							<el-table-column 
								v-for="(dynamicHeaderGroup, dynamicGroupIdx) in getHeaderGroups(dynamicGroup)" 
								:key="`dynamic-group-${bedIndex}-${groupIndex}-${dynamicGroupIdx}`"
								:label="dynamicHeaderGroup.groupName"
								:colspan="dynamicHeaderGroup.columns.length"
								:class-name="dynamicHeaderGroup.markedRed ? 'text-red' : ''"
								align="center">
								<template v-for="(dynamicCol, dynamicIdx) in dynamicHeaderGroup.columns">
									<el-table-column
										:key="`dynamic-${bedIndex}-${groupIndex}-${dynamicGroupIdx}-${dynamicIdx}`"
										:label="dynamicCol.columnZh"
										:width="dynamicCol.width || 100"
										:class-name="dynamicCol.markedRed ? 'text-red' : ''"
										align="center">
										<template slot-scope="scope">
											<!-- 修复数据索引：使用dynamicHeaderGroup.startIndex匹配正确的动态列数据 -->
											<div 
												v-html="scope.row.dynamic[dynamicHeaderGroup.startIndex + dynamicIdx] ? scope.row.dynamic[dynamicHeaderGroup.startIndex + dynamicIdx].dataName : ''"
												:style="{ color: scope.row.dynamic[dynamicHeaderGroup.startIndex + dynamicIdx] && scope.row.dynamic[dynamicHeaderGroup.startIndex + dynamicIdx].markedRed ? 'rgba(255, 77, 79, 1)' : 'rgba(89, 89, 89, 1)' }">
											</div>
										</template>
									</el-table-column>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>

		</div>
		<NoData v-if="isEmpty" />
		<div class="pagination" v-if="pages > 1 && !isEmpty">
			<a-pagination :current="current" :total="total" :defaultPageSize="pageSize" show-less-items
				@change="showSizeChange" />
		</div>
	</div>
</template>

<script>
import NoData from './noData.vue';
export default {
	components: { NoData },
	data() {
		return {
			printObj: {
				id: 'printMe',
				popTitle: '',
			},

			printAllGroups: [],

			isEmpty: true,
			current: 1,
			pages: 2,
			total: 1,
			pageSize: 20,
			preDate: '',
			isShowSeach: true,
			printData: null,
			seachPicker: [],
			totle: 0,
			seachText: '',
			isActive: 0,
			tableData: null,

			highlightRowIndices: [] // 存储需要高亮的行索引
		};
	},
	created() { },
	mounted() {
		this.$refs.view.style.minWidth = window.innerWidth + 'px';

		let date = new Date();
		let endMonth =
			date.getMonth() + 1 >= 10
				? date.getMonth() + 1
				: '0' + (date.getMonth() + 1);
		let endDay = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
		let dataStrEnd = date.getFullYear() + '-' + endMonth + '-' + endDay;
		let dataStrStart = this.getPreMonth(dataStrEnd);

		this.seachPicker.push(...[dataStrStart, dataStrEnd]);
		this.getTableData();
		this.getTableData(1, 20000);
	},
	watch: {

	},
	methods: {

		handleCellMouseEnter(row, column, cell, event) {
			// 清除之前的高亮状态
			this.highlightRowIndices = [];
			
			// 获取当前激活的床位数据
			const currentRecord = this.tableData[this.isActive];
			if (!currentRecord || !currentRecord.measureFlag) return;

			// 找到第一列的合并信息
			const firstColSpans = currentRecord.firstColSpans;
			const rowIndex = this.tableData[this.isActive].dataList.indexOf(row);
			
			// 计算当前单元格所在的合并组
			let startIndex = rowIndex;
			// 向前查找合并组的起始行
			while (startIndex > 0 && firstColSpans[startIndex].rowspan === 0) {
				startIndex--;
			}
			
			// 获取合并组的行数
			const spanCount = firstColSpans[startIndex].rowspan;
			
			// 添加所有需要高亮的行索引
			for (let i = 0; i < spanCount; i++) {
				this.highlightRowIndices.push(startIndex + i);
			}
		},
		
		handleCellMouseLeave(row, column, cell, event) {
			// 清除高亮状态
			this.highlightRowIndices = [];
		},

		headerClass(row) {
      if (row.rowIndex == 1) {
				for (let i = 0; i < row.row.length; i++) {
					return "header-row-display";
				}
      }
    },

		// 处理表头为两级结构
		getHeaderGroups(headerList) {
			if (!headerList || headerList.length === 0) return [];

			const groups = [];
			let currentGroup = null;
			let startIndex = 0;

			headerList.forEach((col, index) => {
				// 判断是否为日期列（根据columnEn格式判断）
				const isDateColumn = this.isDateColumn(col.columnEn);
				
				// 非日期列单独成组
				if (!isDateColumn) {
					if (currentGroup) {
						groups.push({
							groupName: currentGroup.groupName,
							columns: currentGroup.columns,
							startIndex: currentGroup.startIndex,
							markedRed: currentGroup.markedRed  // 传递颜色标记
						});
						currentGroup = null;
					}
					groups.push({
						groupName: col.columnZh, // 一级表头与二级相同
						columns: [col],
						startIndex: index,
						markedRed: col.markedRed  // 继承二级表头颜色标记
					});
					startIndex = index + 1;
					return;
				}

				// 日期列按日期分组
				const date = this.formatDate(col.columnEn);
				if (!currentGroup) {
					currentGroup = {
						groupName: date,
						columns: [col],
						startIndex: index,
						markedRed: col.markedRed  // 初始化颜色标记
					};
				} else if (currentGroup.groupName === date) {
					currentGroup.columns.push(col);
					// 如果有任何二级表头需要红色，则一级表头也设为红色
        	currentGroup.markedRed = currentGroup.markedRed || col.markedRed;
				} else {
					groups.push(currentGroup);
					currentGroup = {
						groupName: date,
						columns: [col],
						startIndex: index,
						markedRed: col.markedRed
					};
				}

				// 处理最后一组
				if (index === headerList.length - 1 && currentGroup) {
					groups.push(currentGroup);
				}
			});

			return groups;
		},

		// 判断是否为日期列
		isDateColumn(columnEn) {
			// 简单判断YYYY-MM-DD格式
			return /^\d{4}-\d{2}-\d{2}$/.test(columnEn);
		},

		// 格式化日期显示（如2025-10-06 -> 10月06日）
		formatDate(dateStr) {
			const [year, month, day] = dateStr.split('-');
			return `${month}月${day}日`;
		},

		// 2. 预计算表格体合并规则：返回各列的rowspan数组
		computeColSpans(dataList, measureFlag) {
			const len = dataList.length;
			// 默认不合并（measureFlag=false或数据行数<=1时生效）
			const defaultSpan = { rowspan: 1, colspan: 1 };
			const firstColSpans = Array(len).fill(defaultSpan); // 第1列（dataName相同合并）
			const secondColSpans = Array(len).fill(defaultSpan); // 第2列（dataVal相同合并）
			const thirdColSpans = Array(len).fill(defaultSpan); // 第3列（dataVal相同合并）
			const fourthColSpans = Array(len).fill(defaultSpan); // 第4列（dataVal相同合并）

			if (!measureFlag || len <= 1) {
				return { firstColSpans, secondColSpans, thirdColSpans, fourthColSpans };
			}

			// -------------------------- 第1列：dataName相同合并 --------------------------
			let firstSpan = 1;
			for (let i = 1; i < len; i++) {
				const prevName = dataList[i - 1][0].dataName;
				const currName = dataList[i][0].dataName;
				if (prevName === currName) {
					firstSpan++;
					firstColSpans[i] = { rowspan: 0, colspan: 1 }; // 被合并行隐藏
				} else {
					firstColSpans[i - firstSpan] = { rowspan: firstSpan, colspan: 1 }; // 合并行设置跨度
					firstSpan = 1;
					firstColSpans[i] = defaultSpan;
				}
			}
			firstColSpans[len - firstSpan] = { rowspan: firstSpan, colspan: 1 }; // 处理最后一组

			// -------------------------- 第2列：dataVal相同合并 --------------------------
			let secondSpan = 1;
			for (let i = 1; i < len; i++) {
				const prevVal = dataList[i - 1][1].dataVal;
				const currVal = dataList[i][1].dataVal;
				if (prevVal === currVal) {
					secondSpan++;
					secondColSpans[i] = { rowspan: 0, colspan: 1 };
				} else {
					secondColSpans[i - secondSpan] = { rowspan: secondSpan, colspan: 1 };
					secondSpan = 1;
					secondColSpans[i] = defaultSpan;
				}
			}
			secondColSpans[len - secondSpan] = { rowspan: secondSpan, colspan: 1 };

			// -------------------------- 第3列：dataVal相同合并 --------------------------
			let thirdSpan = 1;
			for (let i = 1; i < len; i++) {
				const prevVal = dataList[i - 1][2].dataVal;
				const currVal = dataList[i][2].dataVal;
				if (prevVal === currVal) {
					thirdSpan++;
					thirdColSpans[i] = { rowspan: 0, colspan: 1 };
				} else {
					thirdColSpans[i - thirdSpan] = { rowspan: thirdSpan, colspan: 1 };
					thirdSpan = 1;
					thirdColSpans[i] = defaultSpan;
				}
			}
			thirdColSpans[len - thirdSpan] = { rowspan: thirdSpan, colspan: 1 };

			// -------------------------- 第4列：dataVal相同合并 --------------------------
			let fourthSpan = 1;
			for (let i = 1; i < len; i++) {
				const prevVal = dataList[i - 1][3].dataVal;
				const currVal = dataList[i][3].dataVal;
				if (prevVal === currVal) {
					fourthSpan++;
					fourthColSpans[i] = { rowspan: 0, colspan: 1 };
				} else {
					fourthColSpans[i - fourthSpan] = { rowspan: fourthSpan, colspan: 1 };
					fourthSpan = 1;
					fourthColSpans[i] = defaultSpan;
				}
			}
			fourthColSpans[len - fourthSpan] = { rowspan: fourthSpan, colspan: 1 };

			return { firstColSpans, secondColSpans, thirdColSpans, fourthColSpans };
		},
		// 展示用表格的合并方法
		showTableSpanMethod({ row, column, rowIndex, columnIndex }) {
			const currentRecord = this.tableData[this.isActive]; // 当前激活的床位数据
			if (!currentRecord.measureFlag) {
				return { rowspan: 1, colspan: 1 }; // 不合并
			}

			// 按列索引返回合并规则
			switch (columnIndex) {
				case 0: return currentRecord.firstColSpans[rowIndex]; // 第1列
				case 1: return currentRecord.secondColSpans[rowIndex]; // 第2列
				case 2: return currentRecord.thirdColSpans[rowIndex]; // 第3列
				case 3: return currentRecord.fourthColSpans[rowIndex]; // 第4列
				default: return { rowspan: 1, colspan: 1 }; // 其他列不合并
			}
		},

		// 打印用表格的合并方法（传递当前床位的合并信息）
		printTableSpanMethod({ row, column, rowIndex, columnIndex }, bedGroup) {
			if (!bedGroup.measureFlag) {
				return { rowspan: 1, colspan: 1 }; // 不合并
			}

			// 打印表格列：前4列为固定列（对应原1-4列），后续为动态列（不合并）
			if (columnIndex < 4) {
				switch (columnIndex) {
					case 0: return bedGroup.firstColSpans[rowIndex]; // 第1列
					case 1: return bedGroup.secondColSpans[rowIndex]; // 第2列
					case 2: return bedGroup.thirdColSpans[rowIndex]; // 第3列
					case 3: return bedGroup.fourthColSpans[rowIndex]; // 第4列
				}
			}
			return { rowspan: 1, colspan: 1 }; // 动态列不合并
		},


		// 显示表格 - 表头样式
		headerCellStyle() {
			return {
				'background': '#f0f0f0',
				'height': '60px',
				'line-height': '60px',
				'padding': '0 20px',
				'white-space': 'nowrap',
				'border-top': '1px solid #e8e8e8',
				'border-left': '1px solid #e8e8e8'
			}
		},
		// 显示表格 - 单元格样式
		cellStyle() {
			return {
				'height': '60px',
				'padding': '0 20px',
				'white-space': 'nowrap',
				'border-top': '1px solid #e8e8e8',
				'border-left': '1px solid #e8e8e8'
			}
		},
		// 显示表格 - 行样式
		rowClassName({ rowIndex }) {
    // 1. 获取第一列所有合并组
    const firstColMergeGroups = this.getFirstColMergeGroups();
    // 2. 找到当前行所属的合并组
    const targetGroup = firstColMergeGroups.find(group => 
      rowIndex >= group.startRow && rowIndex < group.startRow + group.rowCount
    );

    // 3. 按合并组的“组索引”判断斑马纹（组索引从0开始，0→偶，1→奇...）
    let baseClass = 'row-even'; // 默认偶数组样式
    if (targetGroup) {
      const groupIndex = firstColMergeGroups.indexOf(targetGroup);
      baseClass = groupIndex % 2 === 0 ? 'row-even' : 'row-odd';
    }

    // 4. 保留原高亮逻辑（悬浮时叠加高亮样式）
    return this.highlightRowIndices.includes(rowIndex) 
      ? `${baseClass} highlight-row` 
      : baseClass;
  },

	// 从第一列合并规则中，提取所有合并组（格式：[{startRow: 0, rowCount: 2}, ...]）
  getFirstColMergeGroups() {
    const currentRecord = this.tableData[this.isActive];
    if (!currentRecord || !currentRecord.firstColSpans) return [];

    const mergeGroups = [];
    const firstColSpans = currentRecord.firstColSpans;
    let i = 0;

    while (i < firstColSpans.length) {
      const spanInfo = firstColSpans[i];
      // 跳过被合并的行（rowspan=0），直接定位到合并组的起始行
      if (spanInfo.rowspan === 0) {
        i++;
        continue;
      }
      // 记录当前合并组：起始行索引 + 合并行数
      mergeGroups.push({
        startRow: i,
        rowCount: spanInfo.rowspan // 该组合并了多少行
      });
      // 跳过当前合并组的所有行，直接到下一个组
      i += spanInfo.rowspan;
    }

    return mergeGroups;
  },


		// 打印表格 - 单元格样式
		printCellStyle() {
			return {
				'height': '20px',
				'padding': '0px 0px',
				'white-space': 'nowrap',
				'font-size': '12px',
				'line-height': '20px'
			};
		},
		// 打印表格 - 表头样式
		printHeaderStyle() {
			return {
				'background': '#f0f0f0',
				'height': '30px',
				'padding': '0px 0px',
				'white-space': 'nowrap',
				'font-size': '12px',
				'font-weight': 'bold'
			};
		},
		// 打印表格 - 行样式
		printRowClassName({ rowIndex }) {
			return rowIndex % 2 === 0 ? 'print-row-even' : 'print-row-odd';
		},


		/**
		 * 数据获取（pageSize为20000时是打印用到的数据，非20000则是页面显示的数据）
		 */
		getTableData(pageNum = 1, pageSize = 20) {

			// 判断处理展示数据还是打印数据
			let isPrint = false;
			if (pageSize === 20000) isPrint = true;

			// 参数
			let param = {
				startDate: this.seachPicker[0],
				endDate: this.seachPicker[1],
				searchKeyWord: this.seachText,
				pageSize: pageSize,
				pageNum: pageNum,
			};

			this.total = '...';

			this.$get(
				'/api/healthDataSumCum/healthDataCumPage',
				param,
				(res) => {

					if (res.code == 0) {
						if (isPrint) { // 打印数据
							this.printData = JSON.parse(
								JSON.stringify(res.data.accReportDataVoPage.records)
							);
							this.changeDataPlan(this.printData, true);
							this.printData.forEach(record => {
								const spans = this.computeColSpans(record.dataList, record.measureFlag);
								record.firstColSpans = spans.firstColSpans;
								record.secondColSpans = spans.secondColSpans;
								record.thirdColSpans = spans.thirdColSpans;
								record.fourthColSpans = spans.fourthColSpans;
							});
							this.splitPrintData()
						} else { // 非打印数据
							this.tableData = res.data.accReportDataVoPage.records;
							this.changeDataPlan(this.tableData, false); // 先处理数据格式
							// 为每个床位计算合并规则（表头+表格体）
							this.tableData.forEach(record => {
								const spans = this.computeColSpans(record.dataList, record.measureFlag);
								record.firstColSpans = spans.firstColSpans;
								record.secondColSpans = spans.secondColSpans;
								record.thirdColSpans = spans.thirdColSpans;
								record.fourthColSpans = spans.fourthColSpans;
							});
							// 原有分页逻辑
							this.current = res.data.accReportDataVoPage.current;
							this.pages = res.data.accReportDataVoPage.pages;
							this.total = res.data.accReportDataVoPage.total;
							this.pageSize = res.data.accReportDataVoPage.size;
							this.isEmpty = this.tableData.length === 0;
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},
		changeDataPlan(data, flag) {
			data.forEach((item) => {
				item.dataList.forEach((jtem) => {
					jtem[0].dataName = jtem[0].dataName.replace(/\(/g, '<br /\>(');
				});
			});
		},


		/**
		 * A-pagination 相关内容
		 */
		showSizeChange(data) {
			console.log(data);
			this.current = data;
			this.getTableData(this.current, this.pageSize);
		},



		/**
		 * a-range-picker 相关内容
		 */
		disabledDate(date) {
			let today = new Date(); //当天
			today.setFullYear(today.getFullYear() - 1);
			return (
				date > this.$moment(this.$moment(new Date()).format('YYYY-MM-DD')) ||
				date < this.$moment(this.$moment(today).format('YYYY-MM-DD'))
			);
		},
		onChangeRangeDate(value, dateString) {
			console.log(dateString);
			this.seachPicker = dateString;
			this.seach(3);
		},


		/**
		 * 搜索相关
		 */
		seach(data = 2) {
			console.log(111);
			if (data == 1) {
				if (this.seachText == '') {
					return;
				} else {
					this.isShowSeach = false;
					this.getTableData();
					this.getTableData(1, 20000);
				}
			} else {
				if ((data = 3)) {
					if (this.isShowSeach == true) {
						this.isShowSeach = true;
					}
					this.getTableData();
					this.getTableData(1, 20000);
				} else {
					this.isShowSeach = false;
					this.getTableData();
					this.getTableData(1, 20000);
				}
			}
		},
		back() {
			this.isShowSeach = true;
			this.seachText = '';
			this.seachPicker = [];
			let date = new Date();
			let endMonth =
				date.getMonth() + 1 >= 10
					? date.getMonth() + 1
					: '0' + (date.getMonth() + 1);

			let endDay = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
			let dataStrEnd = date.getFullYear() + '-' + endMonth + '-' + endDay;
			let dataStrStart = this.getPreMonth(dataStrEnd);
			this.seachPicker.push(...[dataStrStart, dataStrEnd]);
			this.getTableData();
			this.getTableData(1, 20000);
		},


		/**
		 * 左侧列
		 */
		changeBedName(data) {
			this.isActive = data;
		},


		/**
		 * 导出相关
		 */
		// 导出表格
		toExportExcele(event) {
			let target = event.target;
			if (target.nodeName == 'SPAN') {
				target = event.target.parentNode;
			}
			target.blur();
			let param = {
				startDate: this.seachPicker[0],
				endDate: this.seachPicker[1],
				searchKeyWord: this.seachText,
			};
			this.$get(
				'/api/v3/accreportdata/exportAccReportDataList',
				param,
				(res) => {
					if (res.code == 0) {
						var a = document.createElement('a'); //创建一个<a></a>标签
						a.href = `/api/v3/accreportdata/downloadFile?filePath=${res.data}`; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
						a.style.display = 'none'; // 障眼法藏起来a标签
						document.body.appendChild(a); // 将a标签追加到文档对象中
						a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
						a.remove(); // 一次性的，用完就删除a标签
						// window.location.href = `${location.origin}/api/api/v3/accreportdata/downloadFile?filePaht=${res.data}`;
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		},

		/**
		 * 工具相关
		 */
		getPreMonth(date) {
			var arr = date.split('-');
			var year = arr[0]; //获取当前日期的年份
			var month = arr[1]; //获取当前日期的月份
			var day = arr[2]; //获取当前日期的日
			var days = new Date(year, month, 0);
			days = days.getDate(); //获取当前日期中月的天数
			var year2 = year;
			var month2 = parseInt(month) - 1;
			if (month2 == 0) {
				year2 = parseInt(year2) - 1;
				month2 = 12;
			}
			var day2 = day;
			var days2 = new Date(year2, month2, 0);
			days2 = days2.getDate();
			if (day2 > days2) {
				day2 = days2;
			}
			if (month2 < 10) {
				month2 = '0' + month2;
			}
			var t2 = year2 + '-' + month2 + '-' + day2;
			return t2;
		},


		/**
		 * 打印相关
		 */
		// 更改打印数据格式入口方法
		changePrintData() {
			let printData = this.printData ? JSON.parse(JSON.stringify(this.printData)) : [];

			// 表头数据
			for (let i = 0; i < printData.length; i++) {
				let allHasData = printData[i].headerList.splice(0, 4);
				console.log(allHasData, 'allHasDataallHasDataallHasData');
				let newHeaderList = this.changeTitleData(printData[i].headerList);

				for (let k = 0; k < newHeaderList.length; k++) {
					newHeaderList[k].unshift(...allHasData);
				}

				let newDataList = [];
				for (let j = 0; j < printData[i].dataList.length; j++) {
					let allHasDataCon = printData[i].dataList[j].splice(0, 4);

					let resData = this.changeDataList(printData[i].dataList[j]);
					resData.forEach((item) => {
						item.splice(0, 0, ...allHasDataCon);
					});
					newDataList.push(resData);
				}
				console.log(newHeaderList, newDataList);
				this.printData[i].headerList = newHeaderList;
				this.printData[i].dataList = newDataList;
			}
		},
		changeTitleData(data) {
			var newData = [];
			var zyf = 6;
			for (var i = 0; i < Math.ceil(data.length / zyf); i++) {
				newData[i] = [];
				newData[i].push(data[i * zyf]);
				for (var j = 1; j < zyf; j++) {
					if (data[i * zyf + j] == undefined) {
						return newData;
					} else {
						newData[i].push(data[i * zyf + j]);
					}
				}
			}
			return newData;
		},
		changeDataList(data) {
			var newData = [];
			var zyf = 6;
			for (var i = 0; i < Math.ceil(data.length / zyf); i++) {
				newData[i] = [];
				newData[i].push(data[i * zyf]);
				for (var j = 1; j < zyf; j++) {
					if (data[i * zyf + j] == undefined) {
						return newData;
					} else {
						newData[i].push(data[i * zyf + j]);
					}
				}
			}
			return newData;
		},
		splitPrintData() {
			this.printAllGroups = [];
			if (!this.printData || this.printData.length === 0) return;

			this.printData.forEach(bedItem => {
				const {
					bedName = '未知床位',
					measureFlag = false,
					firstColSpans = [],
					secondColSpans = [],
					thirdColSpans = [],
					fourthColSpans = [],
					headerList = [], // 处理后的表头（带colspan）
					dataList = []
				} = bedItem;

				// 拆分固定表头（前4列）和动态表头（第五列及以后，按6列分组）
				const headerFixed = headerList.slice(0, 4); // 前4列固定表头
				const dynamicHeader = headerList.slice(4); // 第五列及以后动态表头
				const headerGroups = this.groupArray(dynamicHeader, 6);

				// 拆分数据（固定列+动态列）
				const dataFixed = dataList.map(row => row.slice(0, 4));
				const dataDynamic = dataList.map(row => row.slice(4));

				this.printAllGroups.push({
					bedName,
					measureFlag, // 合并开关
					firstColSpans, // 第1列合并规则
					secondColSpans, // 第2列合并规则
					thirdColSpans, // 第3列合并规则
					fourthColSpans, // 第4列合并规则
					headerFixed, // 处理后的固定表头
					headerGroups, // 处理后的动态表头分组
					dataFixed,
					dataDynamic
				});
			});
		},
		groupArray(arr, groupSize) {
			const groups = [];
			for (let i = 0; i < arr.length; i += groupSize) {
				groups.push(arr.slice(i, i + groupSize));
			}
			return groups;
		},
		formatPrintTableData(bedIndex, groupIndex) {
			// 获取当前床位的打印数据
			const bedGroup = this.printAllGroups[bedIndex] || {};
			const { dataFixed = [], dataDynamic = [] } = bedGroup;
			// 获取当前床位的当前动态分组
			const currentDynamicGroup = bedGroup.headerGroups[groupIndex] || [];

			// 格式化：固定列 + 当前分组的动态列
			return dataFixed.map((fixedRow, rowIndex) => ({
				fixed: fixedRow, // 固定前4列数据
				dynamic: (dataDynamic[rowIndex] || []).slice(
					groupIndex * 6,
					(groupIndex + 1) * 6
				) || [] // 当前分组对应的6列动态数据
			}));
		},

	},
	beforeDestroy() { },
};
</script>
<style scoped lang="scss" media="print">
@page {
	size: auto;
	margin: 3mm;
}

.bed-print-section {
	margin-bottom: 15mm; // 床位之间的间距
	page-break-after: always; // 每个床位打印完成后自动分页
}

.bed-print-section:last-child {
	page-break-after: avoid;
}

.bed-print-title {
	font-size: 16px;
	font-weight: bold;
	color: #333;
	margin-bottom: 5mm;
	text-align: center;
	padding-bottom: 2mm;
	border-bottom: 1px solid #e8e8e8; // 下划线分隔标题和表格
}

.print-table-group {
	margin-bottom: 8mm;
}

.con-table {
	padding: 10px 10px 0;

	.row {
		display: flex;
		background: #f0f0f0;
		align-items: center;
		height: 48px;

		.row-item {
			width: 150px;
			text-align: center;
			white-space: nowrap;
		}
	}

	.row-con {
		display: flex;
		background: #fff;
		align-items: center;
		height: 48px;

		.row-con-item {
			width: 150px;
			height: 100%;
			text-align: center;
			line-height: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top: 1px solid #e8e8e8;
			border-left: 1px solid #e8e8e8;
		}

		.row-con-item:last-child {
			border-right: 1px solid #e8e8e8;
		}
	}

	.row-con:last-child {
		.row-con-item {
			border-bottom: 1px solid #e8e8e8;
		}
	}

	.row-con:nth-child(odd) {
		background: #fafafa;
	}
}
</style>



<style lang="scss" scoped>
// 打印媒体查询

.data-view {
	background: #fff;
	height: 100vh;

	.page-title {
		height: 56px;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 24px;
		box-shadow: 0px 1px 4px -2px rgba(0, 0, 0, 0.5);

		.text {
			position: fixed;
			top: 12px;
			left: 20px;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #262626;
			display: flex;
			align-items: center;

			.text-totle {
				color: #1890ff;
			}

			.text-back {
				color: #1890ff;
				cursor: pointer;
				margin: 10px;
			}

			::v-deep .ant-input {
				height: 28px;
				background: #e6f7ff;
				color: #1890ff;
				border: none;
				height: 32px;
			}

			::v-deep .ant-calendar-range-picker-separator {
				color: #1890ff;
			}

			::v-deep .el-input--mini .el-input__inner {
				height: 32px;
				font-size: 14px;
				padding-left: 12px;
			}
		}

		.top-btn {
			position: fixed;
			top: 12px;
			right: 20px;
		}
	}

	.page-con {
		display: flex;
		align-content: center;
		justify-content: space-between;
		padding-bottom: 40px;
		background: #fff;

		.con-title {
			position: relative;

			.bed-name {
				width: 150px;
				height: 70px;
				cursor: pointer;
				font-size: 14px;
				background: #e6f7ff;
				color: #262626;
				text-align: center;
				display: flex;
				justify-content: center;
				padding-top: 5px;
				border-radius: 0px 8px 0px 0px;
				position: absolute;
			}

			.bed-name-active {
				color: #fff !important;
				background: #1890ff;
			}

			.bed-name:hover {
				color: #1890ff;
			}
		}

		.con-table {
			position: relative;
			top: 0;
			left: 0;
			flex: 1;
			margin: 10px 0 0 160px;

			.row {
				display: flex;
				background: #f0f0f0;
				align-items: center;
				height: 60px;

				.row-item {
					width: 120px;
					height: 60px;
					line-height: 60px;
					padding: 0 20px;
					text-align: center;
					white-space: nowrap;
					border-top: 1px solid #e8e8e8;
					border-left: 1px solid #e8e8e8;
				}
			}

			.row-con {
				display: flex;
				background: #fff;
				align-items: center;
				height: 60px;

				.row-con-item {
					width: 120px;
					height: 100%;
					padding: 0 20px;
					text-align: center;
					white-space: nowrap;
					display: flex;
					align-items: center;
					justify-content: center;
					border-top: 1px solid #e8e8e8;
					border-left: 1px solid #e8e8e8;
				}

				.row-con-item:last-child {
					border-right: 1px solid #e8e8e8;
				}
			}

			.row-con:hover {
				.row-con-item {
					background: #ecf5ff;
				}
			}

			.row-con:last-child {
				border-bottom: 1px solid #e8e8e8;
			}

			.row-con:nth-child(odd) {
				background: #fafafa;
			}
		}
	}

	.pagination {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 160px;
		height: 60px;
		background: #fff;
	}

	.con-table {
		position: fixed;
		top: 0;
		left: 99999999px;
		flex: 1;
		margin: 10px 0 0 160px;

		.row {
			display: flex;
			background: #f0f0f0;
			align-items: center;
			height: 60px;

			.row-item {
				width: 120px;
				padding: 0 20px;
				text-align: center;
				white-space: nowrap;
			}
		}

		.row-con {
			display: flex;
			background: #fff;
			align-items: center;
			height: 60px;

			.row-con-item {
				width: 120px;
				height: 100%;
				padding: 0 20px;
				text-align: center;
				white-space: nowrap;
				display: flex;
				align-items: center;
				justify-content: center;
				border-top: 1px solid #e8e8e8;
				border-left: 1px solid #e8e8e8;
			}

			.row-con-item:last-child {
				border-right: 1px solid #e8e8e8;
			}
		}

		.row-con:last-child {
			.row-con-item {
				border-bottom: 1px solid #e8e8e8;
			}
		}

		.row-con:nth-child(odd) {
			background: #fafafa;
		}
	}
}

// 主表格样式
::v-deep .el-table {
	.el-table__row.row-odd {
		background: #fafafa;
	}

	.el-table__row.row-even {
		background: #fff;
	}

	.el-table__row:hover td {
		background: #ecf5ff !important;
	}

	.el-table__header-wrapper th:last-child {
		border-right: 1px solid #e8e8e8;
	}

	.el-table__body-wrapper td:last-child {
		border-right: 1px solid #e8e8e8;
	}

	.text-red {
		color: #FF4D4F !important;
	}
}

// 打印表格样式
::v-deep #printMe.el-table {
	.el-table__row.print-row-odd {
		background: #fafafa;
	}

	.el-table__row.print-row-even {
		background: #fff;
	}

	.el-table__body-wrapper td {
		border-top: 1px solid #e8e8e8;
		border-left: 1px solid #e8e8e8;
	}

	.el-table__body-wrapper td:last-child {
		border-right: 1px solid #e8e8e8;
	}

	.el-table__row:last-child td {
		border-bottom: 1px solid #e8e8e8;
	}
}

// 打印专用样式（关键：A4横向+分页控制）
@media print {
	@page {
		margin: 13mm 3mm;
	}

	/* 2. 隐藏页面所有冗余元素，只显示打印表格 */
	.page-title,
	.con-title,
	.pagination,
	.el-table--mini~.el-table--mini {
		display: none !important;
	}

	/* 3. 显示打印容器，重置布局 */
	#printMe {
		display: block !important;
		width: 100% !important;
		margin: 0 !important;
		padding: 0 !important;
	}

	/* 4. 子表格分组：每页一个子表格，超限时自动换页 */
	.print-table-group {
		page-break-after: always;
		/* 每个子表格后自动分页 */
		margin-bottom: 10mm;
		/* 页间留白，避免内容粘连 */
	}

	/* 5. 最后一个子表格不加分页符，避免空页 */
	.print-table-group:last-child {
		page-break-after: avoid;
	}

	/* 6. 子表格样式：宽度100%，边框连贯 */
	.print-table-group .el-table {
		width: 100% !important;
		table-layout: fixed !important;
		/* 固定表格布局，避免列错位 */
		border-collapse: collapse !important;
		/* 合并边框，避免重复线条 */
	}

	/* 7. 打印表格奇偶行背景（可选，增强可读性） */
	.print-row-even {
		background: #fafafa !important;
	}

	.print-row-odd {
		background: #fff !important;
	}

	/* 8. 禁止打印时缩放（避免列宽错乱） */
	body {
		zoom: 100% !important;
		-webkit-print-color-adjust: exact !important;
		/* 保留背景色 */
	}
}

</style>

<style lang="scss">
.header-row-display {
  display: none;
}

.data-view {
	.el-table {
		.highlight-row td {
			background-color: #e6f7ff !important;
		}
	}
}
</style>